import React from 'react';
import { GenericListPage } from '../../../components/generic';
import { useManufacturers, Manufacturer } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  return (
    <GenericListPage<Manufacturer>
      useData={useManufacturers}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
